import Base from './Base';

export default class Conversion extends Base {
    get isAnalytics() {
        return Boolean(this.analytics);
    }

    get usersWithConversion() {
        if (!this.isAnalytics) return 0;

        return this.analytics.users_with_conversion;
    }

    get conversionRate() {
        if (!this.isAnalytics) return 0;
        if (!this.analytics.conversion_rate) return '0.0';

        return this.analytics.conversion_rate.toFixed(1);
    }

    get conversionNumber() {
        if (!this.isAnalytics || !this.analytics.conversion_rate) return 0;

        return this.analytics.conversion_rate;
    }

    get conversionValue() {
        if (!this.isAnalytics) return 0;

        return this.analytics.conversion_value;
    }
}
